import React, { Fragment, useEffect, useState } from "react";

import ChannelsAndPacksComponent from "../../CommonUtils/SelectChannelsAndPacks/ChannelsAndPacks/ChannelsAndPacksComponent";
import FilterConfirmation from "../../CommonUtils/SelectChannelsAndPacks/FilterConfirmationComponent/FilterConfirmation";

export default function MessageA13ExploreNonGenric(props) {
  const { code, text } = props.item;

const text_data = JSON.parse(text)
  // console.log(text_data,"hererere")
  // const channelList = text_data?.channels?.channelList || text_data?.selectedChannels?.channelList; 
  // const packList = text_data?.packsWithChannel?.packList || text_data?.selectedChannels?.selectedPacks;
  const channelList = [
    ...(text_data?.channels?.channelList || []),
    ...(text_data?.selectedChannels?.channelList || [])
  ];
  
  const packList = [
    ...(text_data?.packsWithChannel?.packList || []),
    ...(text_data?.selectedPacks?.packList || [])
  ];
  const selectedLanguagesProps = text_data?.filter?.language?.selectedLanguages;

  const allLanguagesProps = text_data?.filter?.language?.listOfLanguages;

  const selectedGenresProps = text_data?.filter?.genre?.selectedGenre;

  const allGenresProps = text_data?.filter?.genre?.listOfGenre;

  const selectedHDSDProps = text_data?.filter?.hdOrSd;

  const [apllied, setApplied] = useState(false);

  const handleFilterApplied = (data) => {
    setApplied(true);
  };

  const handleFilterClickHere = (code, data, tag) => {
    //  console.log(code,data,tag);
    //used to modify filters from packs and selection component
  };
  const onHandleSubmit = (code, data, tag) => {
    props.addMessages(data, code, null, null, null, 'A59');
  };

  // console.log(text_data.filter,"MESSAGEA59")
  return (
    <Fragment>
      {/* {channelList === undefined && packList === undefined ? null : !apllied ? ( */}
      <div className={props?.showMaximumChat && "packs-border"}>
        <ChannelsAndPacksComponent
          {...props}
          packsProps={Array.isArray(text_data) ? text_data : []}
          filters={{ language: "", genre: "", hdOrSd: selectedHDSDProps }}
          prioratizePacks={Array.isArray(text_data?.fullyMatchedPacks) ? text_data.fullyMatchedPacks : []}
          selectedHd={typeof text_data?.filter?.hdOrSd === "string" ? text_data.filter.hdOrSd : ""}
          selectedLanguagesProps={selectedLanguagesProps}
          allLanguagesProps={allLanguagesProps}
          selectedGenresProps={selectedGenresProps}
          allGenresProps={allGenresProps}
          onClickFilter={(code, data, tag) => handleFilterClickHere?.(code, data, tag)}
          onClickSubmit={(code, data, tag) => onHandleSubmit?.(code, data, tag)}
          filterTag="A58"
          filterToggle={(data) => handleFilterApplied?.(data)}
          tag={props.tag}
          code={code}
          preSelectedChannels={text_data?.selectedChannels?.channelList || []}
          preSelectedPacks={text_data?.selectedPacks?.packList || []}
          explorePacks={true}
        />
        </div>
      {/* ) : <div className="A3f">Selected</div>} */}
    </Fragment>
  );
}
